import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HelperService } from '../../../core/services/helper.service';
import { RepoClientsService } from '../../../data/repositories/repo-clients.service';
import { RepoCommonService } from '../../../data/repositories/repo-common.service';
import { SharedDataService } from '../../../data/services/shared-data.service';
import { SharedComponentsModule } from '../../../shared-components.module';
import { getAddressComponents } from '../../../utils/helper-functions/address.functions';
import { BxAddressInputComponent } from '../../../core/components/bx-address-input/bx-address-input.component';

@UntilDestroy()
@Component({
    selector: 'app-add-client',
    templateUrl: './add-client.component.html',
    standalone: false,
})
export class AddClientComponent implements OnInit {
    // @ts-ignore TS2564
    @ViewChild('clientAddForm') clientAddForm: NgForm;

    createOptions: any = {
        Name: '',
        Address: '',
        CityTown: '',
        State: '',
        PostCode: '',
        Phone: '',
        Email: '',
        Mobile: '',
        CustomerType: '',
        Source: '',
    };
    @Output() action = new EventEmitter();

    nameModelChanged = new Subject<string>();
    // @ts-ignore TS7008
    exists;
    clientTypes: string[] = [];
    estimateSources: string[] = [];

    constructor(
        private bsModalRef: BsModalRef,
        private modalOptions: ModalOptions,
        public helperService: HelperService,
        private repoCustomers: RepoClientsService,
        public sharedData: SharedDataService,
        private repoCommon: RepoCommonService
    ) {}

    ngOnInit(): void {
        if (this.modalOptions.initialState) {
            this.createOptions = this.modalOptions.initialState;
        }

        this.nameModelChanged.pipe(untilDestroyed(this), debounceTime(300)).subscribe(() => {
            this.checkCustomerNameUnique();
        });
        this.repoCommon.GetCustomerTypes().then((results) => {
            this.clientTypes = results
                .map((x) => {
                    return x.Description;
                })
                .sort();
        });
        this.repoCommon.GetEstimateSources().then((results: any) => {
            this.estimateSources = results
                // @ts-ignore TS7006
                .map((x) => {
                    return x.Description;
                })
                .sort();
        });
    }

    cancel() {
        this.action.emit({
            cancelled: true,
        });
        this.bsModalRef.hide();
    }

    ok() {
        const customer = this.repoCustomers.Create(this.createOptions);
        this.repoCustomers.Save(customer, 'Client added').then(() => {
            this.bsModalRef.hide();
            this.action.emit({
                cancelled: false,
                result: {
                    customer: customer,
                    options: this.createOptions,
                },
            });
        });
    }

    nameChange() {
        this.nameModelChanged.next('');
    }

    private checkCustomerNameUnique() {
        this.repoCustomers.Exists(this.createOptions.Name).then((exists) => {
            this.exists = exists;
            const ctrl = this.clientAddForm.controls['Name'];
            ctrl?.setErrors(exists ? { unique: true } : null);
            ctrl?.setErrors(ctrl.value.trim() === '' ? { blankValue: true } : null);
        });
    }

    // @ts-ignore TS7006
    handleAddressChange(event: google.maps.places.Place) {
        const addressComponents = getAddressComponents(event);
        const state = this.sharedData.Common.StatesInfo.find(
            // @ts-ignore TS7006
            (s) => s.code === addressComponents.stateName || s.name === addressComponents.stateName
        );

        this.createOptions.Address = addressComponents.addressLine1;
        this.createOptions.CityTown = addressComponents.city;
        this.createOptions.State = state ? state.value : state;
        this.createOptions.PostCode = addressComponents.postcode;
    }
}

@NgModule({
    declarations: [AddClientComponent],
    imports: [CommonModule, FormsModule, TypeaheadModule, SharedComponentsModule, BxAddressInputComponent],
    exports: [AddClientComponent],
})
export class AddClientModule {}
